// extracted by mini-css-extract-plugin
export var result__description = "result-module--result__description--3aef9";
export var result__img = "result-module--result__img--189c7";
export var result__item = "result-module--result__item--817c7";
export var result__list = "result-module--result__list--b3bcd";
export var result__name = "result-module--result__name--1669b";
export var result__title = "result-module--result__title--e52a6";